import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 固定資産管理システムでの扱い */
enum TreatmentFixedAssetControl {
  expenseProcessing = '1',
  noExpenseProcessing = '2',
  noExpenseProcessingIFRS = '3',
}

const nameConfig = {
  expenseProcessing: new Map([[Locale.ja, '費用処理する']]),
  noExpenseProcessing: new Map([[Locale.ja, '費用処理しない']]),
  noExpenseProcessingIFRS: new Map([[Locale.ja, 'IFRSのみ費用処理しない']]),
};

const toEnum = rawValueToEnum(TreatmentFixedAssetControl, TreatmentFixedAssetControl.expenseProcessing);
const toDisplay = enumToName(TreatmentFixedAssetControl, nameConfig);
const toDisplayWithPrefix = enumToName(TreatmentFixedAssetControl, nameConfig, { prefix: true });

export const treatmentFixedAssetControl = {
  enum: TreatmentFixedAssetControl,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { TreatmentFixedAssetControl };
